<template>
    <div>
        <ts-page-title :title="$t('smgActivityLog.pageTitle')" />
        <ts-panel>
            <ts-panel-wrapper>
                <div class="d-flex ts-justify-end">
                    <div class="ts-space-x-3 ts-flex">
                        <div class="row" style="width: 300px;">
                            <label class="ts-text-xs col-md-4 ts-py-2 ts-text-right ts-whitespace-no-wrap">{{
                                $t("smgActivityLog.module") }} :
                            </label>
                            <div class="col-md-8">
                                <a-select v-model="module" :options="moduleList" @change="fetchData" class="ts-w-full"
                                    placeholder="Select"></a-select>
                            </div>
                        </div>
                        <div class="row" style="width: 300px;">
                            <label class="ts-text-xs col-md-4 ts-py-2 ts-text-right ts-whitespace-no-wrap">{{
                                $t("smgActivityLog.action") }} :
                            </label>
                            <div class="col-md-8">
                                <a-select v-model="action" :options="actionList" @change="fetchData" class="ts-w-full"
                                    placeholder="Select"></a-select>
                            </div>
                        </div>
                        <div class="row" style="width: 300px;">
                            <label class="ts-text-xs col-md-4 ts-py-2 ts-text-right ts-whitespace-no-wrap">{{
                                $t("smgActivityLog.status") }} :
                            </label>
                            <div class="col-md-8">
                                <a-select v-model="status" :options="statusList" @change="fetchData" class="ts-w-full"
                                    placeholder="Select"></a-select>
                            </div>
                        </div>
                        <div class="ts-flex ts-space-x-3">
                            <Input search v-model="search" :placeholder="$t('smgActivityLog.search')" :style="width"
                                @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
                            <!-- <ts-filter ref="filter">
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="">{{ $t('employeeProfile.branch') }}</label>
                                        <ts-branch-filter @filter="branchFilter" class="ts-w-full"></ts-branch-filter>
                                    </div>
                                </div>
                            </ts-filter> -->
                        </div>
                    </div>
                </div>
            </ts-panel-wrapper>
            <Table :columns="columns" :data="resources" size="small" :loading="loading" max-height="700" stripe>
                <template slot-scope="{ row }" slot="status">
                    <span v-if="row.status == 'success'"
                        class="badge bg-success tw-capitalize px-2 fs-12px d-inline-flex ts-capitalize">
                        {{ row.status }}
                    </span>
                    <span v-if="row.status == 'fail'"
                        class="badge bg-danger tw-capitalize px-2 fs-12px d-inline-flex ts-capitalize">
                        {{ row.status }}
                    </span>
                </template>
            </Table>
            <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
                <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
            </div>
        </ts-panel>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { debounce } from "lodash";
import { mapActions, mapState } from "vuex";
import expandRow from "./table-expand.vue";

export default {
    name: "serviceTicket",
    data() {
        return {
            loading: false,
            errors: new Errors(),
            width: "width: 300px",
        };
    },
    computed: {
        ...mapState("customerService/smgActivityLog", ["resources", "pagination", "formViewDatas"]),
        search: {
            get() {
                return this.$store.state.customerService.smgActivityLog.search;
            },
            set(newValue) {
                this.$store.commit(
                    "customerService/smgActivityLog/SET_SEARCH",
                    newValue
                );
                this.$store.commit(
                    "customerService/smgActivityLog/RESET_CURRENT_PAGE"
                );
            }
        },
        branch_id: {
            get() {
                return this.$store.state.customerService.smgActivityLog
                    .branch_id
            },
            set(newValue) {
                this.$store.commit(
                    'customerService/smgActivityLog/SET_BRANCH_ID',
                    newValue
                )
            }
        },
        module: {
            get() {
                return this.$store.state.customerService.smgActivityLog
                    .module;
            },
            set(newValue) {
                this.$store.commit(
                    "customerService/smgActivityLog/SET_TICKET_MODULE",
                    newValue
                );
            }
        },
        status: {
            get() {
                return this.$store.state.customerService.smgActivityLog
                    .status;
            },
            set(newValue) {
                this.$store.commit(
                    "customerService/smgActivityLog/SET_STATUS",
                    newValue
                );
            }
        },
        action: {
            get() {
                return this.$store.state.customerService.smgActivityLog
                    .action;
            },
            set(newValue) {
                this.$store.commit(
                    "customerService/smgActivityLog/SET_ACTION",
                    newValue
                );
            }
        },
        columns() {
            return [
                {
                    type: "expand",
                    render: (h, params) => {
                        return h(expandRow, {
                            props: {
                                row: params.row
                            }
                        });
                    },
                    align: "center",
                    width: 40
                },
                {
                    title: this.$t("smgActivityLog.createdDate"),
                    key: "created_date",
                    minWidth: 180,
                    sortable: true
                },
                {
                    title: this.$t("smgActivityLog.createdBy"),
                    minWidth: 150,
                    key: "created_by_name",
                    sortable: true
                },
                {
                    title: this.$t("smgActivityLog.module"),
                    key: "module",
                    minWidth: 120,
                    sortable: true
                },
                {
                    title: this.$t("smgActivityLog.action"),
                    key: "action",
                    minWidth: 120,
                    sortable: true
                },
                {
                    title: this.$t("smgActivityLog.status"),
                    slot: "status",
                    minWidth: 100,
                    sortable: true
                },
                {
                    title: this.$t("smgActivityLog.description"),
                    key: "description",
                    minWidth: 500,
                    sortable: true
                },
                {
                    title: this.$t("smgActivityLog.refObjectId"),
                    key: "ref_object_id",
                    align: "center",
                    minWidth: 280,
                    sortable: true
                },
            ];
        },
        statusList() {
            if (this.formViewDatas.status) {
                return this.formViewDatas.status;
            }
            return [];
        },
        moduleList() {
            if (this.formViewDatas.modules) {
                return this.formViewDatas.modules;
            }
            return [];
        },
        actionList() {
            if (this.formViewDatas.actions) {
                return this.formViewDatas.actions;
            }
            return [];
        },

    },
    methods: {
        ...mapActions("customerService/smgActivityLog", ["getFormViewModel"]),
        fetchFilterData() {
            this.getFormViewModel({
                params: {},
                index: undefined
            });
        },
        fetchData(attributes) {
            this.loading = true;
            this.$store
                .dispatch("customerService/smgActivityLog/fetch", {
                    ...attributes
                })
                .then(() => {
                    this.loading = false;
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                });
        },
        branchFilter(branch_id) {
            this.branch_id = branch_id
            this.fetchData();
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "SERVICE TICKET",
                desc: not.text
            });
        }
    },
    watch: {
        search: debounce(function () {
            this.fetchData();
        }, 500),
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchFilterData();
            vm.fetchData();
        })
    }
};
</script>
<style>
.w-fit-content button {
    height: 32px;
}
</style>